import { TableCell } from 'ui/tableCell';
import type { NewFieldTableColumnData } from './types';

export const NEW_FIELDS_TABLE_COLUMNS_JSON: NewFieldTableColumnData[] = [
  {
    name: 'Field name',
    align: 'flex-start',
    value: 'fieldName',
    sortable: false,
    RowCell: ({ row }) => <TableCell>{row.fieldName}</TableCell>,
  },
  {
    name: 'Sample data',
    align: 'flex-start',
    value: 'sample1',
    sortable: false,
    RowCell: ({ row }) => <TableCell>{row.sample1}</TableCell>,
  },
];

export const NEW_FIELDS_TABLE_COLUMNS_FILE: NewFieldTableColumnData[] = [
  ...NEW_FIELDS_TABLE_COLUMNS_JSON,
  {
    name: '',
    align: 'flex-start',
    value: 'sample2',
    sortable: false,
    RowCell: ({ row }) => <TableCell>{row.sample2}</TableCell>,
  },
];

export const FIELD_TYPES = {
  string: 'string',
  long: 'long',
  double: 'double',
  boolean: 'boolean',
  date: 'date',
  object: 'object',
  geo_location: 'geo_location',
} as const;

export const FIELD_TYPES_FILTER_OPTIONS = Object.keys(FIELD_TYPES).map((filterOption) => {
  return {
    value: filterOption,
    label: filterOption,
  };
});

export const MODE = {
  view: 'view',
  define: 'define',
  confirm: 'confirm',
} as const;

export const MESSAGE_COPY = {
  [MODE.view]: (num: number) => `Found ${num} undefined fields`,
  [MODE.define]: 'Review the type suggestions for each undefined field...',
  [MODE.confirm]: <strong>Are you sure these changes are correct?</strong>,
};

export const MESSAGE_ACTION_COPY = {
  [MODE.view]: 'Define now',
  [MODE.define]: 'Define later',
  [MODE.confirm]: 'Go back',
};

export const FIELDS_UPDATED_TIMEOUT_MESSAGE =
  'Your field types have not finished being defined. Please check again later and re-upload your items then';

export const FIELD_TYPES_HELP_TEXT = {
  [FIELD_TYPES.geo_location]: (
    <>
      Geo-Location can only have the format{' '}
      <pre>{JSON.stringify({ lat: 12.345, lon: -12.345 }, null, 2)}</pre>
    </>
  ),
  [FIELD_TYPES.long]: 'Longs are used for integers',
  [FIELD_TYPES.double]: 'Doubles are used for decimal values',
  [FIELD_TYPES.object]: 'Objects cannot be nested. Its children can be typed',
  array:
    'Catalogs store array fields as multi-value and hence they have the same type as a single value field',
  default: 'Types can only be defined once',
};

export const SUCCESS_RESP = 'Successfully updated field type';

export const FIELD_TYPES_SELECT_OPTIONS = Object.keys(FIELD_TYPES).map((option) => ({
  value: option,
  label: option,
  Suffix: FIELD_TYPES_HELP_TEXT[option as keyof typeof FIELD_TYPES_HELP_TEXT],
}));
